import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_44f349lcoo: FaireBrandEntity = {
  token: "b_44f349lcoo",
  type: "brand",
  name: "NIKIBIKI",
  avatarUrl:
    "https://cdn.faire.com/fastly/8cc8b68f7bc73073ed9ac2b24cb6bf2d7ab8c666bba3321768643ead92957d92.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f9a7635f1d1d8b5fae741b1754c250ecd3629177399afd3449dbd7ebd14dde63.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8cc8b68f7bc73073ed9ac2b24cb6bf2d7ab8c666bba3321768643ead92957d92.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f9a7635f1d1d8b5fae741b1754c250ecd3629177399afd3449dbd7ebd14dde63.jpeg",
  location: "Vernon, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 470,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 2001, Nikibiki is a global leader in women's apparel manufacturing and wholesale distribution. We proudly present an eclectic collection of quality basics for everyday wear. Proudly manufactured in Los Angeles, California, our seamless line is a solid addition to both online and brick-and-mortar boutiques worldwide.\n\nAt Nikibiki, we’re committed to providing excellent quality seamless wear for fans across the world. To ensure a high standard of quality, we have chosen to manufacture all of our seamless products in Los Angeles, California as opposed to importing them from other countries. Manufacturing domestically allows us to uphold and enforce our strict dedication to flawless seamless production. \n\nThis is what sets us apart from the rest: Quality above all else. Our factory is also designed to reduce waste and improve quality, all while empowering our employees to be a part of the team.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:22.678Z",
    importedBy: "entity-db-cli",
  },
};
